import Head from 'next/head';
import Image from 'next/image';
import Carousel from "react-bootstrap/Carousel";
import Link from "next/link";
import { useState } from 'react';
import SeoHead from '../component/SeoHead';
import metaData from '../data/Meta.json';
import { jsonLdByPath } from '../data/SchemaTag.js';
import { useRouter } from "next/navigation";

export async function getServerSideProps(context) {
  const path = context.resolvedUrl.toLowerCase();

  const matchedMeta = metaData.find(item => item.url?.toLowerCase().endsWith(path)) || {};

  const pageJson = jsonLdByPath.find(item => item.url?.toLowerCase().endsWith(path));

  const title = matchedMeta?.title || 'Millance';
  const description = matchedMeta?.description || 'Trade smarter with Millance.';
  const url = matchedMeta?.url || `https://millance.com${path}`;
  const jsonLd = pageJson || null;

  return {
    props: { meta: { title, description, url }, jsonLd, }
  };
}

export default function Home({ meta, jsonLd }) {
  const slides = [
    {
      id: 7,
      title: "Smart Investment Strategies",
      highlight: "Grow your portfolio effortlessly with PAMM & Copy Trading",
      text: "Invest with expert traders and earn profits without actively trading. Let professionals manage your funds while you enjoy the returns. Mirror the strategies of top-performing traders in real time. Simply choose a trader, copy their trades, and grow your portfolio effortlessly.",
      imgSrc: ("/images/banner/8.png"),

    },
    {
      id: 2,
      title: "Diversify Your Portfolio",
      highlight: "Copy trade Forex, CFDs, Indices, & Commodities with competitive spreads",
      text: "Gain access to Forex, CFDs, Indices, and Commodities with low spreads for a cost-effective trading experience. Copy trade global markets with tight pricing, ensuring better profit potential and reduced costs. ",
      imgSrc: ("/images/banner/banner34.png"),
    },
    {
      id: 3,
      title: "Precision & Speed ",
      highlight: "Experience ultra-fast order execution for seamless trading",
      text: "Enjoy lightning-speed trade execution, ensuring minimal slippage and maximum efficiency—trade global markets with confidence, tight pricing, and precision.",
      imgSrc: ("/images/banner/3.png"),
    },
    {
      id: 4,
      title: "Maximize Your Capital ",
      highlight: "Get a 50% deposit bonus and enhance your trading potential",
      text: "Boost your trading power with a 50% deposit bonus! Get extra funds added to your account when you deposit, giving you more capital to trade Forex, CFDs, Indices, and Commodities. ",
      imgSrc: ("/images/banner/4.png"),
    },
    {
      id: 5,
      title: " Seamless USDT Transactions",
      highlight: " Secure, fast, and hassle-free deposits & withdrawals",
      text: "Experience hassle-free USDT transactions with zero delays and secure processing. Enjoy fast deposits and withdrawals, seamless conversions, and a smooth trading experience with ultra-low fees. ",
      imgSrc: ("/images/banner/there.png"),
    },
    {
      id: 6,
      title: "Advanced Trading Infrastructure",
      highlight: " Experience a seamless, secure, high-performance trading environment.",
      text: "Enjoy a smooth and efficient trading environment with ultra-fast execution, low spreads, and seamless transactions. Copy trade confidently, backed by a secure and reliable platform designed for beginners and professionals. ",
      imgSrc: ("/images/banner/6.png"),
    },
    {
      id: 1,
      title: "Zero Deposit Fees, Maximum Opportunity",
      highlight: "Start trading with just $100",
      text: "Start trading effortlessly with zero deposit fees and a minimum deposit of just $100. Every dollar you deposit goes directly into your copy trades, giving you more value for your money. ",
      imgSrc: ("/images/banner/banner13.png"),
    }

  ];
  const [showText, setShowText] = useState(Array(slides.length).fill(false));

  const router = useRouter();
  const onNavi = () => {
    router.push("https://crm.millance.com/register");
  }
  return (
    <>
      <SeoHead title={meta.title} description={meta.description} jsonLd={jsonLd} url={meta.url} />
      <div id="top">
        <>
          <div className="homesec">
            <div className="bubbles">
              <div className="bubble">
                <img
                  src={"/images/04.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="bubble">
                <img
                  src={"/images/02.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="bubble">
                <img
                  src={"/images/03.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="bubble">
                <img
                  src={"/images/04.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="bubble">
                <img
                  src={"/images/02.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="bubble">
                <img
                  src={"/images/03.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="bubble">
                <img
                  src={"/images/01.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="bubble">
                <img
                  src={"/images/02.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="bubble">
                <img
                  src={"/images/03.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="bubble">
                <img
                  src={"/images/04.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="container-fuild">

              <div className="banner  mb-4 mt-4">
                <Carousel fade interval={3000} indicators={false}>
                  {slides.map((slide, i) => (
                    <Carousel.Item key={i + 'banner'}>
                      <div className="container">
                        <div className="row align-items-center">
                          <div className="col-md-12 col-lg-6">
                            <div className="bannerhead">
                              <h1 className="">{slide.title}</h1>
                              <h1>
                                <span style={{ color: "#ee4d14" }}>{slide.highlight}</span>
                              </h1>
                              {showText[i] && <p className="mb-3">{slide.text}</p>}
                              <div className="d-flex mt-4">
                                <button
                                  type="button"
                                  className="btn btn-primary trade-now-but"
                                  onClick={() => {
                                    const newShowText = [...showText];
                                    newShowText[i] = !newShowText[i];
                                    setShowText(newShowText);
                                  }}

                                >
                                  {showText[i] ? "Read less" : "Read more"}
                                </button>
                                <button className="me-3 regulated"> Regulated Broker</button>
                              </div>

                            </div>
                          </div>
                          <div className="col-md-12 col-lg-6">
                            <div className="banner-img">
                              <img
                                src={slide.imgSrc}
                                alt="logo"
                                className="img-fluid bannerimg1"

                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </div>
            <iframe
              allowtransparency="true"
              frameBorder="0"
              src="https://s.tradingview.com/embed-widget/ticker-tape/?locale=en#%7B%22symbols%22%3A%5B%7B%22description%22%3A%22AUD%2FUSD%22%2C%22proName%22%3A%22FX%3AAUDUSD%22%7D%2C%7B%22description%22%3A%22EUR%2FJPY%22%2C%22proName%22%3A%22FX%3AEURJPY%22%7D%2C%7B%22description%22%3A%22EUR%2FUSD%22%2C%22proName%22%3A%22FX%3AEURUSD%22%7D%2C%7B%22description%22%3A%22GBP%2FJPY%22%2C%22proName%22%3A%22FX%3AGBPJPY%22%7D%2C%7B%22description%22%3A%22GBP%2FUSD%22%2C%22proName%22%3A%22FX%3AGBPUSD%22%7D%2C%7B%22description%22%3A%22USD%2FCAD%22%2C%22proName%22%3A%22FX%3AUSDCAD%22%7D%2C%7B%22description%22%3A%22USD%2FJPY%22%2C%22proName%22%3A%22FX%3AUSDJPY%22%7D%5D%2C%22colorTheme%22%3A%22light%22%2C%22isTransparent%22%3Atrue%2C%22displayMode%22%3A%22adaptive%22%2C%22width%22%3A%22100%25%22%2C%22height%22%3A44%2C%22utm_source%22%3A%22www.millance.com%22%2C%22utm_medium%22%3A%22widget%22%2C%22utm_campaign%22%3A%22ticker-tape%22%2C%22page-uri%22%3A%22www.millance.com%2Findex.php%22%7D"
              style={{
                boxSizing: "border-box",
                // height: "44px",
                width: "100%",
                position: "relative",
                // bottom: "68px",
              }}
            ></iframe>{" "}
            <div className="valsec"></div>
            <div className="why-choose mt-2">
              <div className="container">
                <div className="choose-text text-center">
                  <h2 className="mb-5">Why Choose Millance?</h2>

                  <div className="row">
                    <div className="col-lg-4">
                      <div className="row">
                        <div className="col-lg-12">
                          <img
                            src={"/images/algoimg/singupicon1.png"}
                            alt="logo"
                            className="img-fluid "
                          />
                          <div className="card">
                            <strong className="text-center mb-2 mt-3">
                              Intuitive & User-Friendly Platform{" "}
                            </strong>
                            <p className="text-center">
                              {" "}
                              Whether you&apos;re a beginner or an experienced trader, our
                              interface is designed for effortless navigation and
                              seamless execution.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-12 mt-5">
                          <img
                            src={"/images/algoimg/depositicon1.png"}
                            alt="logo"
                            className="img-fluid "
                          />
                          <div className="card">
                            <strong className="text-center mb-2 mt-3">
                              Competitive Spreads & Low Fees
                            </strong>
                            <p className="text-center">
                              {" "}
                              Maximize profitability with some of the industry&apos;s
                              lowest fees and minimal spreads.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <img
                        src={"/images/home/chooseus-1.png"}
                        alt="logo"
                        className="new-up img-fluid"
                      />
                      <div className="col-lg-12">
                        <img
                          src={"/images/algoimg/tradeicon1.png"}
                          alt="logo"
                          className="img-fluid "
                        />
                        <div className="card">
                          <strong className="text-center mb-2 mt-3">
                            IB Broker{" "}
                          </strong>
                          <p className="text-center">
                            {" "}
                            Join as an Introducing Broker (IB) and grow your earnings by referring traders to our platform. Enjoy high commission payouts, real-time tracking, and a seamless partnership experience.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="row">

                        <div className="col-lg-12">
                          <img
                            src={"/images/algoimg/tradeicon1.png"}
                            alt="logo"
                            className="img-fluid "
                          />
                          <div className="card">
                            <strong className="text-center mb-2 mt-3">
                              Security & Reliability{" "}
                            </strong>
                            <p className="text-center">
                              {" "}
                              Your funds and personal data are safeguarded by
                              state-of-the-art encryption and secure servers, ensuring
                              a trusted trading experience.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-12 mt-5">
                          <img
                            src={"/images/algoimg/verifyicon1.png"}
                            alt="logo"
                            className="img-fluid "
                          />
                          <div className="card">
                            <strong className="text-center mb-2 mt-3">
                              24/7 Dedicated Support
                            </strong>
                            <p className="text-center">
                              {" "}
                              Our professional support team is available
                              round-the-clock, providing expert assistance and
                              personalized solutions.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="about">
              <div className="container">
                <div className="row">
                  <div className="col-lg-7 m-auto">
                    <h2>About Millance</h2>

                    <p>
                      Millance LTD is a leading provider of online forex trading,
                      contract-for-difference (CFD) trading, and financial
                      services. Our diverse account types and tailored solutions
                      cater to traders of all experience levels, ensuring an
                      inclusive and efficient trading ecosystem.
                    </p>
                    <p>
                      With tight spreads and 24/7 customer support, we remain
                      committed to delivering an outstanding trading
                      experience,whether you&apos;re a novice or a seasoned trader.
                    </p>

                    <Link href="/about-us">
                      <button
                        type="button"
                        className="btn btn-primary trade-now-but about-but"
                      >
                        Read more
                      </button>
                    </Link>
                  </div>
                  <div className="col-lg-5 abt-img">
                    <img
                      src={"/images/home/about-img.png"}
                      alt="logo"
                      className="img-fluid "
                    />
                  </div>

                </div>
              </div>
            </div>
            {/* <div className="trade-assets-home">
            <div className="trade-asset-home-titl">
              <h2>Trade Asset</h2>
              <p>Millance LTD offers a wide range of trading opportunities, including currency instruments, indices, metals, and more. Start trading with us and elevate your financial journey!</p>
            </div>
            <div className="container">
              <div className="row>">
                <div className="col">
                </div>
              </div>
            </div>
          </div> */}

            <section className="getmt5 mt-4 pb-5 pt-4">
              <div className="getsmt5">
                <div className="container">

                  <div className="row mt-5 align-items-center">
                    <div className="col-lg-6">
                      <div className="getimg">
                        <img
                          src={"/images/home/getstartimg1.gif"}
                          alt="logo"
                          className="img-fluid homeget "
                        />
                      </div>
                      <div className="d-flex justify-content-center getsbtn mt-3 ">
                        <div className="openlivebtn">
                          <Link href="https://crm.millance.com/register">
                            <button id="blinking-button" type="button" className="btn btn-primary">
                              Open Live Account
                            </button>
                          </Link>
                        </div>
                        <div className="opendemobtn">
                          <Link href="https://crm.millance.com/opendemoaccount">
                            <button id="blinking-button" type="button" className="btn btn-primary">
                              Open Demo Account
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-6">
                      <h2 className="text-start mb-3">
                        Get Started with the Millance LTD Trading Platform!{" "}
                      </h2>
                      <p className="getapara text-start">
                        Start trading anytime, anywhere with ease. Our platform is
                        built for efficiency, security, and ease of use.
                      </p>
                      <div className="row mt-5">
                        <div className="col-md-12 col-lg-6 mb-5">
                          <div className="homebox1get">
                            <div className="signim">
                              <img
                                src={"/images//algoimg/singupicon1.png"}
                                alt="logo"
                                className="img-fluid mb-3"
                              />
                              <h5 className="my-1 mb-3 ms-3">Register</h5>

                            </div>
                            <div className="signcont">
                              <p className="mb-0 font-13">
                                Sign up and create your trading account in
                                minutes.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 col-lg-6 mb-5">
                          <div className="homebox1get">
                            <div className="signim">
                              <img
                                src={"/images//algoimg/verifyicon1.png"}
                                alt="logo"
                                className="img-fluid mb-3"
                              />
                              <h5 className="my-1 mb-3 ms-3">Verify</h5>

                            </div>
                            <div className="signcont">
                              <p className="mb-0 font-13">
                                Upload the d documents for instant
                                verification.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 col-lg-6 mb-5">
                          <div className="homebox1get">
                            <div className="signim">
                              <img
                                src={"/images/algoimg/depositicon1.png"}
                                alt="logo"
                                className="img-fluid "
                              />
                              <h5 className="my-1 mb-3 ms-3">Deposit</h5>

                            </div>
                            <div className="signcont">
                              <p className="mb-0 font-13">
                                Fund your account with a minimum of $100.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 col-lg-6 mb-5">
                          <div className="homebox1get">
                            <div className="signim">
                              <img
                                src={"/images/algoimg/tradeicon1.png"}
                                alt="Best Platform For Forex Trading In the world"
                                className="img-fluid "
                              />
                              <h5 className="my-1 mb-3 ms-3">Copy trade</h5>

                            </div>
                            <div className="signcont">
                              <p className="mb-0 font-13">
                                Start trading across a range of instruments and
                                maximize your potential!
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </section>


            <section id="pricing-9" className="pricing">
              <div className="container">
                <div className="text-center">
                  <h2>Account Type</h2>
                  <p>
                    At Millance Ltd, we offer intelligently designed investment
                    solutions tailored to your trading needs. Choose from a range of
                    account types, each providing exceptional benefits and optimal
                    trading conditions to suit traders of all levels.
                  </p>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="pricing-plan-title-style9 pricing-plan-style9-bg priceplan-title-style9-before clearfix">
                      <h3>Standard</h3>
                    </div>
                    <div className="pricing-plan-wrap">
                      <div className="pricing-plan-header">
                        <div className="price-holder">
                          <p className="dolar">$100</p>
                          <sub>Minimum deposit</sub>

                          {/* <sub>/mont</sub> */}
                        </div>{/* <!-- end price-holder --> */}
                      </div>{/* <!-- end pricing-plan-header --> */}
                      <ul className="list-unstyled">
                        <li><h3>Novice Trader</h3> </li>
                        <li>Spread From 1.3 pips</li>
                        <li>Platform : MT5</li>
                        <li>Leverage 1:400</li>
                        <li>Commission:0</li>
                        <li>Swap:Yes</li>
                      </ul>{/* <!-- end list --> */}
                      <div>
                        <button className="btn-custom" onClick={() => onNavi()}><i className="animation"></i>Open Account Now<i className="animation"></i>
                        </button>
                      </div>
                      {/* <div>
                      <button className="btn-custom"><i className="animation"></i>BUTTON<i className="animation"></i>
                      </button>
                    </div> */}
                    </div>{/* <!-- end pricing-plan-wrap --> */}
                  </div>{/* <!-- end pricing-plan --> */}
                  <div className="col-md-4">

                    <div className="pricing-plan-title-style9 pricing-plan-style9-bg priceplan-title-style9-before clearfix">
                      <h3>Premium</h3>
                      {/* <b>Most popular</b> */}
                    </div>
                    <div className="pricing-plan-wrap active">
                      {/* <span className="most">Most Popular</span> */}

                      <div className="pricing-plan-header">
                        <div className="price-holder">
                          <p className="dolar">$1000</p>
                          <sub>Minimum deposit</sub>

                        </div>
                      </div>
                      {/* Spread From 0.5pips
    Platform : MT5
    Leverage 1:200
    Commission: $5/lot
    Swap:Yes */}
                      <ul className="list-unstyled">
                        <li><h3> Progressive Trader</h3> </li>
                        <li>Spread From 0.5 pips</li>
                        <li>Platform : MT5</li>
                        <li>Leverage 1:200</li>
                        <li> Commission: $5/lot</li>
                        <li>Swap:Yes</li>
                      </ul>
                      <div>
                        <button className="btn-custom" onClick={() => onNavi()}><i className="animation"></i>Open Account Now<i className="animation"></i>
                        </button>
                      </div>
                    </div>{/* <!-- end pricing-plan-wrap --> */}
                  </div>{/* <!-- end pricing-plan --> */}
                  <div className="col-md-4">
                    <div className="pricing-plan-title-style9 pricing-plan-style9-bg priceplan-title-style9-before clearfix">
                      <h3>Elite</h3>
                    </div>
                    <div className="pricing-plan-wrap">
                      <div className="pricing-plan-header">
                        <div className="price-holder">
                          <p className="dolar">$500</p>
                          <sub>Minimum deposit</sub>
                        </div>{/* <!-- end price-holder --> */}
                      </div>{/* <!-- end pricing-plan-header --> */}





                      {/* Spread From 1.1pips
    Platform MT5
    Leverage 1:300
    Commission:0
    Swap:Yes */}

                      <ul className="list-unstyled">
                        <li><h3> Experienced Trader</h3> </li>
                        <li>Spread From 1.1 pips</li>
                        <li>Platform : MT5</li>
                        <li>Leverage 1:300</li>
                        <li> Commission: 0</li>
                        <li>Swap:Yes</li>
                      </ul>
                      <div>
                        <button className="btn-custom" onClick={() => onNavi()}><i className="animation"></i>Open Account Now<i className="animation"></i>
                        </button>
                      </div>
                    </div>{/* <!-- end pricing-plan-wrap --> */}
                  </div>{/* <!-- end pricing-plan --> */}

                </div>{/* <!-- end row --> */}
              </div>{/* <!-- end container --> */}
            </section>

            {/* <div className="account-type-home pt-4 pb-5"> */}
            {/* <h2>Account Type</h2>
            <p>
              At Millance Ltd, we offer intelligently designed investment
              solutions tailored to your trading needs. Choose from a range of
              account types, each providing exceptional benefits and optimal
              trading conditions to suit traders of all levels.
            </p> */}
            {/* <div className="container">
              <div className="cards-price">
                <div className="card-price shadow">
                  <ul>
                    <li className="pack">Basic</li>
                    <li id="basic" className="price bottom-bar">&dollar;199.99</li>
                    <li className="bottom-bar">500 GB Storage</li>
                    <li className="bottom-bar">2 Users Allowed</li>
                    <li className="bottom-bar">Send up to 3 GB</li>
                    <li><button className="btn">Learn More</button></li>
                  </ul>
                </div>
                <div className="card-price active">
                  <ul>
                    <li className="pack">Professional</li>
                    <li id="professional" className="price bottom-bar">&dollar;249.99</li>
                    <li className="bottom-bar">1 TB Storage</li>
                    <li className="bottom-bar">5 Users Allowed</li>
                    <li className="bottom-bar">Send up to 10 GB</li>
                    <li><button className="btn active-btn">Learn More</button></li>
                  </ul>
                </div>
                <div className="card-price shadow">
                  <ul>
                    <li className="pack">Master</li>
                    <li id="master" className="price bottom-bar">&dollar;399.99</li>
                    <li className="bottom-bar">2 TB Storage</li>
                    <li className="bottom-bar">10 Users Allowed</li>
                    <li className="bottom-bar">Send up to 20 GB</li>
                    <li><button className="btn">Learn More</button></li>
                  </ul>
                </div>
              </div>

            </div> */}
            {/* <div className="millance price pricing">

              <div className="pricing-cards">
                <div className="pricing-card">
                  <div className="card-type">Standerd</div>

                  <h1 className="card-price">100$</h1>
                  <div>
                    <button className="btn"><i className="animation"></i>Minimum Deposit<i className="animation"></i>
                    </button>
                  </div>


                  <div className="depnext">Novice Trader</div>
                  <div className="list">
                    <div className="list-item">

                      <span>Spread From 1.3 pips</span>
                    </div>
                    <div className="list-item">

                      <span>Platform : MT5</span>
                    </div>
                    <div className="list-item">

                      <span>Leverage 1:400</span>
                    </div>
                    <div className="list-item">

                      <span>Commission:0</span>
                    </div>
                    <div className="list-item">

                      <span>Swap:Yes</span>
                    </div>
                  </div>

                  <button className="sheen card-bottom">Open Account Now</button>
                </div> */}

            {/* <div className="pricing-card">
                  <span className="most">Most Popular</span>
                  <div className="card-type">PREMIUM</div>

                  <h1 className="card-price"> 1000$</h1>
                  <div>
                    <button className="btn"><i className="animation"></i>Minimum Deposit<i className="animation"></i>
                    </button>
                  </div>


                  <div className="depnext">Progressive Trader</div>
                  <div className="list">
                    <div className="list-item">

                      <span>Spread From 1.3 pips</span>
                    </div>
                    <div className="list-item">

                      <span>Platform : MT5</span>
                    </div>
                    <div className="list-item">

                      <span>Leverage 1:400</span>
                    </div>
                    <div className="list-item">

                      <span>Commission:0</span>
                    </div>
                    <div className="list-item">

                      <span>Swap:Yes</span>
                    </div>
                  </div>

                  <button className="sheen card-bottom">Open Account Now</button>
                </div>

                <div className="pricing-card">
                  <div className="card-type">ELITE</div>

                  <h1 className="card-price">500$</h1>

                  <div>
                    <button className="btn"><i className="animation"></i>Minimum Deposit<i className="animation"></i>
                    </button>
                  </div>


                  <div className="depnext">Experienced Trader</div>
                  <div className="list">
                    <div className="list-item">

                      <span>Spread From 1.3 pips</span>
                    </div>
                    <div className="list-item">

                      <span>Platform : MT5</span>
                    </div>
                    <div className="list-item">

                      <span>Leverage 1:400</span>
                    </div>
                    <div className="list-item">

                      <span>Commission:0</span>
                    </div>
                    <div className="list-item">

                      <span>Swap:Yes</span>
                    </div>

                  </div>

                  <button className="sheen card-bottom">Open Account Now</button>
                </div> */}

            {/* </div>
            </div> */}
            {/* <div className="pricing">
              <div className="plan">
                <img
                  src={"/images/home/plan1.gif"}
                  alt="logo"
                  className="img-fluid "
                />
                <div className="price">Novice Trader</div>
                <ul className="features">

                  <li>
                    Spread <span> From 1.3 pips</span>{" "}
                  </li>
                  <li>Platform : MT5 </li>
                  <li>
                    Leverage <span> 1:400</span>
                  </li>
                  <li>
                    Commission:<span>0</span>
                  </li>
                  <li>
                    Swap:<span>Yes</span>
                  </li>
                </ul>
                <a
                >
                  <button type="button">Open Account Now</button>
                </a>
              </div>
              <div className="plan popular">
                <span>Most Popular</span>
                <img
                  src={"/images/home/plan3.gif"}
                  alt="logo"
                  className="img-fluid "
                />
                <div className="price">Progressive Trader</div>
                <ul className="features">
                  <li>Spread From 0.5pips </li>
                  <li>Platform : MT5 </li>
                  <li>Leverage 1:200</li>
                  <li>Commission: $5/lot</li>
                  <li>Swap:Yes</li>
                </ul>
                <a
                >
                  <button type="button">Open Account Now</button>
                </a>
              </div>
              <div className="plan">
                <img
                  src={"/images/home/plan2.gif"}
                  alt="logo"
                  className="img-fluid "
                />
                <div className="price">Experienced Trader</div>
                <ul className="features">

                  <li>
                    Spread <span> From 1.1pips</span>{" "}
                  </li>
                  <li>
                    Platform <span> MT5</span>{" "}
                  </li>
                  <li>
                    Leverage <span> 1:300</span>
                  </li>
                  <li>
                    Commission:<span>0</span>
                  </li>
                  <li>
                    Swap:<span>Yes</span>
                  </li>
                </ul>
                <a
                >
                  <button type="button">Open Account Now</button>
                </a>
              </div>
            </div> */}
            {/* </div> */}
            <div className="teade-asses-home">
              <div className="">
                <div className="container">
                  <div className="row">
                    <div className="why-choose-first">
                      <h2>Diverse Trading Asset</h2>
                      <p>
                        Gain access to a broad selection of trading asset. Copy trade
                        CFDs on forex pairs, indices, metals, energy, stocks, and
                        futures with low trading costs and flexible leverage
                        options. Capitalize on every market movement with
                        Millance’s advanced trading solutions.
                      </p>
                    </div>
                    <div className="d-flex justify-content-center">

                      <div className="slide me-4">
                        <img
                          src={"/images/home/8icon.png"}
                          alt="logo"
                          className="img-fluid "
                        />
                        <h5> Currency</h5>
                      </div>
                      <div className="slide me-4">
                        <img
                          src={"/images/home/9icon.png"}
                          alt="logo"
                          className="img-fluid "
                        />
                        <h5> Commodities</h5>
                      </div>
                      <div className="slide me-4">
                        <img
                          src={"/images/home/121icon.png"}
                          alt="logo"
                          className="img-fluid mt-4"
                        />
                        <h5 className="mt-1"> Indices</h5>
                      </div>
                    </div>
                    {/* <div className="why-choose-img">
                    <Carousels
                      swipeable={false}
                      draggable={false}
                      showDots={false}
                      responsive={responsive1}
                      autoPlay={true}
                      ssr={true}
                      infinite={true}
                      autoPlaySpeed={1500}
                      keyBoardControl={true}
                      className="slider1"
                      slidesToShow={1}
                      slidesToScroll={1}
                      transitionDuration={500}
                      containerClass="carousel-container justify-content-center"
                      removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
                      dotListClass="custom-dot-list-style"
                      itemClass="carousel-item-padding-40-px"
                    >
                      <div className="slide">
                        <img
                          src={"/images/home/8icon.png"}
                          alt="logo"
                          className="img-fluid "
                        />
                        <h5> Currency</h5>
                      </div>
                      <div className="slide">
                        <img
                          src={"/images/home/9icon.png"}
                          alt="logo"
                          className="img-fluid "
                        />
                        <h5> Commodities</h5>
                      </div>
                      <div className="slide">
                        <img
                          src={"/images/home/121icon.png"}
                          alt="logo"
                          className="img-fluid mt-4"
                        />
                        <h5> Indices</h5>
                      </div>
                      <div className="slide">
                        <img
                          src={"/images/home/8icon.png"}
                          alt="logo"
                          className="img-fluid "
                        />
                        <h5> Currency</h5>
                      </div>
                      <div className="slide">
                        <img
                          src={"/images/home/9icon.png"}
                          alt="logo"
                          className="img-fluid "
                        />
                        <h5> Commodities</h5>
                      </div>
                      <div className="slide">
                        <img
                          src={"/images/home/121icon.png"}
                          alt="logo"
                          className="img-fluid "
                        />
                        <h5> Indices</h5>
                      </div>
                    </Carousels>
                  </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt5 pt-0 pb-5">
              <div className="mt5-trade1">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="">
                        <img
                          src={"/images/home/homegif.gif"}
                          alt="logo"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mt5-trade-cont">
                      <div className="banner-texy">
                        <div className="why-choose-first home-mt-trader">
                          <h2>MetaTrader 5 – Advanced Trading Made Simple!</h2>
                        </div>
                        <p className="multiass">
                          MetaTrader 5 is a multi-asset trading platform that
                          enables trading in forex, stocks, futures, and various
                          other financial instruments.
                        </p>

                        <p>
                          It features a powerful trading system with market depth
                          and a separate accounting system for orders and copy trades.
                          The platform supports two types of order accounting
                          systems: the traditional netting system and the hedging
                          option system.with four order execution methods spot,
                          request, market, and exchange execution. MetaTrader 5
                          caters to different trading strategies. It also provides
                          advanced price analysis tools, algorithmic trading
                          applications (trading robots and expert advisors), and
                          efficient copy trading features.
                        </p>

                        <div className="home-mt-sec">
                          <div className="meta5 home-io-mc">
                            <div className="container">
                              <div className="row mt-4">
                                <div className="col-md-12 col-lg-4 android">
                                  <div className="appdownloadicons d-flex align-items-center">
                                    <div className="appicon1">
                                      {" "}
                                      <img
                                        src={"/images/accountype/android.png"}
                                        alt="Forex Traders In India"
                                        className="img-fluid mx-3"
                                      />
                                    </div>
                                    <div className="appicon2">
                                      {" "}
                                      <a
                                        href="https://download.mql5.com/cdn/mobile/mt5/android?utm_source=www.metatrader5.com&utm_campaign=install.metaquotes"
                                        className="dropdown-item"
                                      // onClick={handleCaptureClick}
                                      >
                                        <p>Download For</p> <h6>Android</h6>{" "}
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12 col-lg-4 ios">
                                  <div className="appdownloadicons d-flex align-items-center">
                                    <div className="appicon1">
                                      {" "}
                                      <img
                                        src={"/images/accountype/mac.png"}
                                        alt="logo"
                                        className="img-fluid mx-3 ios-mobi"
                                      />
                                    </div>
                                    <div className="appicon2">
                                      <a
                                        className="dropdown-item"
                                        href="https://download.mql5.com/cdn/mobile/mt5/ios?utm_source=www.metatrader5.com&utm_campaign=install.metaquotes
                            "
                                      >
                                        <p>Available on the</p>
                                        <h6>IOS</h6>
                                      </a>
                                    </div>
                                    <div className="ios-mac-line">/</div>
                                    <div className="appicon2">
                                      <a
                                        className="dropdown-item"
                                        href="https://download.mql5.com/cdn/mobile/mt5/ios?utm_source=www.metatrader5.com&utm_campaign=install.metaquotes
                            "
                                      >
                                        <h6 className="ios-home">MAC</h6>
                                      </a>
                                    </div>
                                    <div className="appicon1">
                                      {" "}
                                      <img
                                        src={"/images/accountype/ios.png"}
                                        alt="logo"
                                        className="img-fluid mx-3 mac-lap "
                                      />
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="col-md-12 col-lg-3">
                <div className="appdownloadicons d-flex align-items-center">
                  <div className="appicon1">
                    <img
                      src={"/images/accountype/mac.png"}
                      alt="logo"
                      className="img-fluid mx-3"
                    />
                  </div>
                  <div className="appicon2">
                    {" "}
                    <p>Download For</p>
                    <h6>Mac</h6>
                  </div>
                </div>
              </div> */}
                                <div className="col-md-12 col-lg-4 windowss">
                                  <div className="appdownloadicons d-flex align-items-center">
                                    <div className="appicon1">
                                      <img
                                        src={"/images/accountype/windows.png"}
                                        alt="logo"
                                        className="img-fluid mx-3 "
                                      />
                                    </div>
                                    <div className="appicon2">
                                      <a
                                        className="dropdown-item"
                                        /* href="https://download.mql5.com/cdn/web/19448/mt5/millance5setup.exe" */
                                        download
                                      >
                                        {" "}
                                        <p>Download For</p>
                                        <h6>Windows</h6>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="vertical-carousel-container">

              <div className="indrocing-brok">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 mb-3">
                      <div className="aboutus text-center">
                        <h2>
                          Partner with Millance LTD – Introducing Brokers &
                          Institutional Programs
                        </h2>
                        <h4>
                          Boost Your Earnings with Industry-Leading Rebates &
                          Commissions!
                        </h4>
                        <p>
                          Millance LTD offers exclusive Institutional
                          Programs, including Introducing Broker, Affiliate
                          Program, Prime of Primes, and Franchise Partnership
                          strategically designed to maximize your profits and
                          elevate your business success.
                        </p>

                      </div>
                    </div>
                    <div className="col-lg-6 mb-3">
                      <div className="aboutus">
                        <div className="why-choose-first news-blog-title ">
                          <h2> Market News & Trading Insights</h2>
                        </div>

                        <h4>
                          Stay ahead of the market with real-time updates,
                          expert analysis, and game-changing trading insights!
                        </h4>
                        <p>
                          Our dedicated team delivers the latest financial news,
                          exclusive trading tips, and lucrative opportunities
                          helping you make informed decisions every step of the
                          way.
                        </p>
                      </div>
                    </div>
                  </div>
                  <Link href="https://crm.millance.com/register">
                    <button
                      type="button"
                      className="btn btn-primary trade-now-but about-but mt-4">
                      Register Now
                    </button>
                  </Link>
                </div>
              </div>

            </div>
            <div className="go-next">
              <div className="why-choose-first">
                <h2>Choose Where to Go Next</h2>
                <p>
                  Millance Ltd has evolved into a premier international trading
                  platform, empowering traders with unmatched opportunities in the
                  financial markets.
                </p>
              </div>

              {/* <Choosemillance /> */}
            </div>
            <section className="fastsecure mt-3">
              <div className="fastsectrade brand-home">
                <div className="container">
                  <h2 className="text-center mb-3">
                    Fast, Secure & Hassle-Free Transactions
                  </h2>
                  <p>
                    Enjoy instant and secure deposits, ensuring you&apos;re ready to
                    trade within minutes. With low or zero-fee transaction
                    options, you retain more capital for market opportunities.
                  </p>
                  <div className="accslider">
                    {/* <Carousels
                    swipeable={false}
                    draggable={false}
                    showDots={false}
                    responsive={responsive3}
                    autoPlay={true}
                    ssr={true} // means to render carousel on server-side.
                    infinite={true}
                    autoPlaySpeed={1500}
                    keyBoardControl={true}
                    className="slider1 mt-4"
                    slidesToShow={1}
                    slidesToScroll={1}
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                  >
                    <div className="accsli1">
                      <img
                        src={"/images/home/visa.png"}
                        alt="logo"
                        className="img-fluid "
                      />
                    </div>
                    <div className="accsli1">
                      <img
                        src={"/images/home/debit.png"}
                        alt="logo"
                        className="img-fluid "
                      />
                    </div>
                    <div className="accsli1">
                      <img
                        src={"/images/home//skrill.png"}
                        alt="logo"
                        className="img-fluid "
                      />
                    </div>
                    <div className="accsli1">
                      <img
                        src={"/images/home/net.png"}
                        alt="logo"
                        className="img-fluid "
                      />
                    </div>
                    <div className="accsli1">
                      <img
                        src={"/images/home/bankwire.png"}
                        alt="logo"
                        className="img-fluid "
                      />
                    </div>
                    
                    <div className="accsli1">
                      <img
                        src={"/images/home/fastpay.png"}
                        alt="logo"
                        className="img-fluid "
                      />
                    </div>
                    <div className="accsli1">
                      <img
                        src={"/images/home/bit-coin-logo-bot.png"}
                        alt="logo"
                        className="img-fluid "
                      />
                    </div>

                    <div className="accsli1">
                      <img
                        src={"/images/home/meta-qu.png"}
                        alt="logo"
                        className="img-fluid "
                      />
                    </div>

                    <div className="accsli1">
                      <img
                        src={"/images/home/american-ex.png"}
                        alt="logo"
                        className="img-fluid "
                      />
                    </div>
                  
                  </Carousels> */}
                    <div className="accsli1">
                      <img
                        src={"/images/home/tether-ico.png"}
                        alt="logo"
                        className="img-fluid m-auto d-block "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="App">
              {/* <div><iframe className="m-w-100 chat_box" src="https://www.smatbot.com/kya_backend/share?code=millance_Ltd_15959" style={{border:'0',width:'500px',height:'auto', position:'fixed', bottom:'0', zIndex:'999999', right:'5%', minHeight:'504px'}} ></iframe></div> */}
            </div>
          </div>
        </>
      </div>
    </>
  );
}
